import axios from 'axios';

export const login = async (credentials) => {
  try {
    const response = await axios.post('http://127.0.0.1:8000/user/login', credentials, {
      headers: {
        'Content-Type': 'application/json',
        'accept': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}; 